import React from 'react'

import AddButton from '../AddButton'
import CloseButton from '../CloseButton'

interface ToggleButtonPropsInterface {
  handleClick: () => any

  addLabel: string
  removeLabel: string
  addDataElement: string
  removeDataElement: string

  isOpen: boolean
  isDisabled: boolean
}

export default ({
  isOpen,
  addLabel,
  removeLabel,
  addDataElement,
  removeDataElement,
  handleClick,
  isDisabled,
}: ToggleButtonPropsInterface) =>
  isOpen ? (
    <CloseButton
      dataElement={removeDataElement}
      onClick={handleClick}
      disabled={isDisabled}
    >
      {removeLabel}
    </CloseButton>
  ) : (
    <AddButton
      dataElement={addDataElement}
      onClick={handleClick}
      disabled={isDisabled}
    >
      {addLabel}
    </AddButton>
  )
